import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import twLocale from './tw'
import locale from 'element-ui/lib/locale';
Vue.use(VueI18n)

const messages = {
    'en': enLocale,
    'zh': zhLocale,
    'tw': twLocale
}

const i18n = new VueI18n({
    locale: 'zh', // set locale
    messages // set locale messages
})
locale.i18n((key, value) => i18n.t(key, value))
export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js